import { Injectable } from "@angular/core";
import { Router } from "@angular/router";

@Injectable()
export class LoginRouteGuard  {
  constructor(public router: Router) {}

  canActivate() {
    sessionStorage.removeItem("empnum");
    const subscriptionReturnPage = localStorage.getItem("subscriptionReturnPage");
    if (subscriptionReturnPage) {
      localStorage.removeItem("subscriptionReturnPage");
      if (
        window.location.pathname.toLowerCase() == "/login" ||
        window.location.pathname.toLowerCase() == "/home" ||
        window.location.pathname.toLowerCase() == "/bidline"
      ) {
        sessionStorage.setItem("activePage", subscriptionReturnPage);
        const url = window.location.href;
        const queryStringValue =
          url.indexOf("?") > -1 ? url.split("?")[1].split("=")[1] : "";
        localStorage.setItem("paymentReturnValue", queryStringValue);
        this.router.navigate(["/" + subscriptionReturnPage]);
        return false;
      }
    }
    sessionStorage.setItem("activePage", "login");
    return true;
  }
}

@Injectable()
export class RegistrationGuard  {
  constructor(public router: Router) {}

  canActivate() {
    const temp_empnum = sessionStorage.getItem("activePage");
    if (temp_empnum == "home") {
      this.router.navigate(["/home"]);
      return false;
    } else {
      const temp = sessionStorage.getItem("temp_empnum");
      if (temp) {
        return true;
      } else {
        this.router.navigate(["/login"]);
      }
    }
  }
}

@Injectable()
export class HomeGuard  {
  constructor(public router: Router) {}

  canActivate() {
    const temp_active_page = sessionStorage.getItem("activePage");
    if (temp_active_page && temp_active_page == "home") return true;
    else {
      if (temp_active_page == "bidline") return true;
      //this.router.navigate(['/' + temp_active_page])
      else this.router.navigate(["/login"]);
      return false;
    }
  }
}

@Injectable()
export class BidlineGuard  {
  constructor(private router: Router) {}

  canActivate() {
    const temp_active_page = sessionStorage.getItem("activePage");
    if (temp_active_page && temp_active_page == "bidline") return true;
    else {
      // if (temp_active_page)
      //   this.router.navigate(['/' + temp_active_page])
      // else
      this.router.navigate(["/login"]);
      return false;
    }
  }
}

@Injectable()
export class PrivacyPolicyGuard {
  constructor(private router: Router) {}

  canActivate() {
    return true;
  }
}
